import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { customerQueries } from '@as-react/common-queries';
import { sortAlphabetically } from '@as-react/common-utils';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { AccountOverviewInfo } from '../../components/account/account-overview-info/AccountOverviewInfo';
const AccountOverviewInfoContainer = ({ editProfileLink, title, }) => {
    const { defaultRequestParams, servicesEndpoint, lang } = useAemConfig();
    const { getCountries, getProfile } = customerQueries({ servicesEndpoint, defaultRequestParams });
    const { data: countries } = useQuery(getCountries({
        select: data => sortAlphabetically(data, `countryDescriptionTranslations.${lang.toUpperCase()}`),
    }));
    const { data: customerProfile } = useQuery(getProfile());
    const customerCountry = useMemo(() => {
        if (!customerProfile || !countries) {
            return '';
        }
        const currentCountry = countries.find(country => country.idCountry === customerProfile.address.idCountry);
        return currentCountry.countryDescriptionTranslations[lang.toUpperCase()];
    }, [customerProfile, countries, lang]);
    if (!customerProfile) {
        return null;
    }
    return (_jsx(AccountOverviewInfo, { country: customerCountry, profile: customerProfile, editProfileLink: editProfileLink, title: title }));
};
export default AccountOverviewInfoContainer;
